import {
  AlertTitle,
  Alert as MuiAlert,
  AlertProps as MuiAlertProps,
  styled,
  Typography,
} from "@mui/material";

/**
 * AlertTight is a styled alert component that is used to display a title and text in a more tight layout.
 */

const StyledAlertTight = styled(MuiAlert)<{ closeIconColor?: string }>(({ closeIconColor }) => ({
  padding: "12px",
  position: "relative",
  "& .MuiAlert-icon": {
    marginRight: "8px",
    padding: 0,
  },
  "& .MuiAlert-message": {
    padding: 0,
    paddingRight: "32px", // Make room for close button
  },
  "& .MuiAlert-action": {
    position: "absolute",
    top: "8px",
    right: "8px",
    padding: 0,
    marginRight: 0,
    alignItems: "flex-start",
    "& .MuiIconButton-root": {
      padding: "4px",
      color: closeIconColor || "inherit",
    },
  },
}));

interface AlertTightProps extends MuiAlertProps {
  title: string;
  text: string;
  textColor?: string;
  closeIconColor?: string;
}

export const AlertTight: React.FC<AlertTightProps> = ({
  title,
  text,
  textColor,
  closeIconColor,
  ...props
}) => {
  return (
    <StyledAlertTight {...props} closeIconColor={closeIconColor}>
      <AlertTitle fontSize={14} sx={{ fontWeight: 600, p: 0, m: 0, pt: 0.2, color: textColor }}>
        {title}
      </AlertTitle>
      <Typography variant="body2" sx={{ maxWidth: { xs: "100%", md: "1076px" }, color: textColor }}>
        {text}
      </Typography>
    </StyledAlertTight>
  );
};

export default AlertTight;
